import { ConfirmDialog, Flex } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { SponsorTile } from './components/SponsorTile'
import {
  useEffect,
  usePersistedUserData,
  useQueryParams,
  useState,
  useVertical,
} from 'src/hooks'
import { SponsorSearchWindow } from './components/SponsorSearchWindow'
import { useUsers } from 'src/react_query'
import { SponsorFragment } from 'src/legacy_graphql'

export const sponsorSelectionCopy = {
  title: 'Who showed you this product?',
  message: (clientName: string) =>
    `We celebrate and give back to the people who invite others to experience ${clientName}. Let us know who showed you our products and we will make sure they are given the credit they deserve!`,
}

type SponsorSearchTileProps = {
  isAffiliateJoining: boolean
  dialogsZIndex?: number
  onSelectSponsor: (genealogyId: string) => void
  mobileBreakPoint?: number
  selectedGenId?: string
}

export const SponsorSearchTile = (props: SponsorSearchTileProps) => {
  const {
    isAffiliateJoining,
    dialogsZIndex,
    onSelectSponsor,
    mobileBreakPoint,
    selectedGenId,
  } = props

  const { account } = usePersistedUserData()
  const { sponsor: sponsorParam } = useQueryParams()
  const vertical = useVertical()

  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

  const [genId, setGenId] = useState<string | undefined>(
    selectedGenId ?? account?.sponsor?.genealogyId?.toString(),
  )

  //  One hook for both deep-link and detail lookup
  const { data: hits } = useUsers(
    { search: genId ?? '', offset: 0, limit: 1, isAffiliate: false },
    Boolean(genId),
  )

  //  Only once, on mount, if there's a URL param and we haven't seeded yet
  useEffect(() => {
    if (sponsorParam && genId === undefined) {
      setGenId(sponsorParam)
      onSelectSponsor(sponsorParam)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sponsorParam, onSelectSponsor])
  const sponsor = hits?.[0] as SponsorFragment | undefined

  const handleManualSelect = (_userId: string, newGenId: string) => {
    setGenId(newGenId)
    onSelectSponsor(newGenId)
    setIsSearchOpen(false)
  }

  return (
    <>
      <ConfirmDialog
        zIndex={dialogsZIndex}
        isOpen={isInfoModalOpen}
        title={sponsorSelectionCopy.title}
        description={sponsorSelectionCopy.message(vertical.name)}
        accept={{
          title: 'Got it',
          onClick: () => setIsInfoModalOpen(false),
        }}
        primaryAction={'accept'}
        onClose={() => setIsInfoModalOpen(false)}
      />
      <SponsorSearchWindow
        isOpen={isSearchOpen}
        isAffiliateJoining={isAffiliateJoining}
        mobileBreakPoint={mobileBreakPoint}
        onClose={() => setIsSearchOpen(false)}
        onSelectSponsor={handleManualSelect}
      />
      <Flex width="100%">
        <SponsorTile
          sponsor={sponsor}
          onOpenSearch={() => setIsSearchOpen(true)}
          isAffiliateJoining={isAffiliateJoining}
          onOpenInfoModal={() => setIsInfoModalOpen(true)}
        />
      </Flex>
    </>
  )
}
